import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import Duck from 'extensible-duck';
import { createSelector } from 'reselect';

var _excluded = ["id"];
var prepareFields = function prepareFields(fields, customPropertyValues) {
  if (customPropertyValues === void 0) {
    customPropertyValues = {};
  }
  var typeMap = {
    // Custom property types
    dropdown: 'Dropdown',
    short_answer: 'Text',
    number: 'Number',
    url: 'Text',
    paragraph: 'Text',
    radio: 'Radio',
    boolean: 'Boolean',
    checkbox: 'Checkbox',
    // Standard property types
    first_name: 'Text',
    last_name: 'Text',
    address: 'Address',
    phone_number: 'Text',
    gender: 'Text',
    birthday: 'Text',
    date: 'Date'
  };
  return fields.map(function (field) {
    var _field$connected_prop, _field$connected_prop2, _field$connected_prop3, _field$connected_prop4;
    var formattedFields = {
      id: field === null || field === void 0 ? void 0 : (_field$connected_prop = field.connected_property) === null || _field$connected_prop === void 0 ? void 0 : _field$connected_prop.id,
      title: field === null || field === void 0 ? void 0 : field.label,
      description: field === null || field === void 0 ? void 0 : field.description,
      type: typeMap === null || typeMap === void 0 ? void 0 : typeMap[field === null || field === void 0 ? void 0 : (_field$connected_prop2 = field.connected_property) === null || _field$connected_prop2 === void 0 ? void 0 : _field$connected_prop2.type],
      required: field === null || field === void 0 ? void 0 : field.required,
      order: field === null || field === void 0 ? void 0 : field.order,
      options: field === null || field === void 0 ? void 0 : (_field$connected_prop3 = field.connected_property) === null || _field$connected_prop3 === void 0 ? void 0 : _field$connected_prop3.options
    };
    if (customPropertyValues[field === null || field === void 0 ? void 0 : (_field$connected_prop4 = field.connected_property) === null || _field$connected_prop4 === void 0 ? void 0 : _field$connected_prop4.id]) {
      var _field$connected_prop5;
      formattedFields.defaultValue = customPropertyValues[field === null || field === void 0 ? void 0 : (_field$connected_prop5 = field.connected_property) === null || _field$connected_prop5 === void 0 ? void 0 : _field$connected_prop5.id];
    }
    return formattedFields;
  });
};
var popups = function popups(duck) {
  return {
    popups: new Duck.Selector(function () {
      return createSelector(duck.selectors.topScopeLoader, function (_ref) {
        var _ref$popups = _ref.popups,
          popups = _ref$popups === void 0 ? [] : _ref$popups;
        return [].concat(popups).sort(function (_ref2, _ref3) {
          var a = _ref2.order;
          var b = _ref3.order;
          return a - b;
        });
      });
    }),
    scopedPopups: new Duck.Selector(function () {
      return createSelector(function (state, scope) {
        var _state$duck$store, _state$duck$store$sco;
        if (scope === void 0) {
          scope = 'guest';
        }
        return state === null || state === void 0 ? void 0 : (_state$duck$store = state[duck.store]) === null || _state$duck$store === void 0 ? void 0 : (_state$duck$store$sco = _state$duck$store[scope]) === null || _state$duck$store$sco === void 0 ? void 0 : _state$duck$store$sco.popups;
      }, function (popups) {
        if (popups === void 0) {
          popups = [];
        }
        return [].concat(popups).sort(function (_ref4, _ref5) {
          var a = _ref4.order;
          var b = _ref5.order;
          return a - b;
        });
      });
    }),
    getAdditionalPopups: new Duck.Selector(function () {
      return createSelector(duck.selectors.topScopeLoader, function (_ref6) {
        var _ref6$additionalPopup = _ref6.additionalPopups,
          additionalPopups = _ref6$additionalPopup === void 0 ? [] : _ref6$additionalPopup;
        return additionalPopups;
      });
    }),
    // because of popup optimization, if we go from
    // guest -> authed and vice versa
    // the later store has the cached popups
    allPopups: new Duck.Selector(function () {
      return createSelector(function (state) {
        return duck.selectors.scopedPopups(state, 'user');
      }, function (state) {
        return duck.selectors.scopedPopups(state);
      }, duck.selectors.getAdditionalPopups, duck.selectors.getDefaultRegisteredPopup, duck.selectors.getDefaultAnonPopup, function (userPopups, guestPopups, additionalPopups, registeredPopup, anonPopup) {
        var registeredPopupId = registeredPopup === null || registeredPopup === void 0 ? void 0 : registeredPopup.id;
        var anonPopupId = anonPopup === null || anonPopup === void 0 ? void 0 : anonPopup.id;
        var allPopups = [];
        if (registeredPopupId && anonPopupId) {
          allPopups = [].concat(userPopups.filter(function (popup) {
            return (registeredPopupId && anonPopupId) !== (popup === null || popup === void 0 ? void 0 : popup.id);
          }), guestPopups.filter(function (popup) {
            return (registeredPopupId && anonPopupId) !== (popup === null || popup === void 0 ? void 0 : popup.id);
          }), [registeredPopup, anonPopup], additionalPopups);
        } else if (anonPopupId) {
          allPopups = [].concat(userPopups.filter(function (popup) {
            return anonPopupId !== (popup === null || popup === void 0 ? void 0 : popup.id);
          }), guestPopups.filter(function (popup) {
            return anonPopupId !== (popup === null || popup === void 0 ? void 0 : popup.id);
          }), [anonPopup], additionalPopups);
        } else if (registeredPopupId) {
          allPopups = [].concat(userPopups.filter(function (popup) {
            return registeredPopupId !== (popup === null || popup === void 0 ? void 0 : popup.id);
          }), guestPopups.filter(function (popup) {
            return registeredPopupId !== (popup === null || popup === void 0 ? void 0 : popup.id);
          }), [registeredPopup], additionalPopups);
        } else {
          allPopups = [].concat(userPopups, guestPopups, additionalPopups);
        }
        return allPopups.sort(function (_ref7, _ref8) {
          var a = _ref7.order;
          var b = _ref8.order;
          return a - b;
        });
      });
    }),
    customProperties: new Duck.Selector(function () {
      return createSelector(duck.selectors.topScopeLoader, function (_ref9) {
        var custom_properties = _ref9.custom_properties;
        return custom_properties;
      });
    }),
    popupNewsletters: function popupNewsletters(state, popupId) {
      var _popups$find;
      var popups = duck.selectors.allPopups(state);
      return ((_popups$find = popups.find(function (_ref10) {
        var id = _ref10.id;
        return popupId === id;
      })) === null || _popups$find === void 0 ? void 0 : _popups$find.newsletters) || [];
    },
    popupAuthenticationMethods: new Duck.Selector(function () {
      return createSelector(duck.selectors.popupGetPopupById, function (popup) {
        return ((popup === null || popup === void 0 ? void 0 : popup.authentication_methods) || []).length ? popup.authentication_methods : ['email'];
      });
    }),
    popupPlanOptions: new Duck.Selector(function () {
      return createSelector(duck.selectors.popups, function (popups) {
        return popups.filter(function (_ref11) {
          var type = _ref11.type;
          return type === 'offer';
        }).reduce(function (options, popup) {
          var _popup$products;
          popup === null || popup === void 0 ? void 0 : (_popup$products = popup.products) === null || _popup$products === void 0 ? void 0 : _popup$products.forEach(function (product) {
            options = [].concat(options, product.options);
          });
          return options;
        }, []).map(function (_ref12) {
          var id = _ref12.id,
            rest = _objectWithoutPropertiesLoose(_ref12, _excluded);
          return Object.assign({
            plan_option_id: id,
            id: id
          }, rest);
        });
      });
    }),
    popupUserOffer: function popupUserOffer(state) {
      var currentProductOptionId = duck.selectors.currentProductOptionId(state);
      if (!currentProductOptionId) {
        return null;
      }

      // const currentProductOptionId = '5c00c747-4089-48af-a1d5-f04795f38100'
      var popups = duck.selectors.popups(state);
      var userOffer = popups.reduce(function (acc, _temp) {
        var _ref13 = _temp === void 0 ? {} : _temp,
          products = _ref13.products;
        var offer = products === null || products === void 0 ? void 0 : products.find(function (_ref14) {
          var id = _ref14.id;
          return id === currentProductOptionId;
        });
        if (offer) {
          return offer;
        }
        return acc;
      }, null);
      return userOffer;
    },
    popupGetProductByProductOptionId: new Duck.Selector(function () {
      return createSelector(duck.selectors.allPopups, function (_, productOptionId) {
        return productOptionId;
      }, function (allPopups, productOptionId) {
        var products = allPopups.reduce(function (acc, _temp2) {
          var _ref15 = _temp2 === void 0 ? {} : _temp2,
            products = _ref15.products;
          return [].concat(acc, products ? products : []);
        }, []);
        var product = products.find(function (_ref16) {
          var _ref16$options = _ref16.options,
            options = _ref16$options === void 0 ? [] : _ref16$options;
          return options.some(function (option) {
            return (option === null || option === void 0 ? void 0 : option.id) === productOptionId || (option === null || option === void 0 ? void 0 : option.short_code) === productOptionId;
          });
        });
        return product;
      });
    }),
    popupGetOptionById: new Duck.Selector(function () {
      return createSelector(function (state, optionId) {
        return duck.selectors.popupGetProductByProductOptionId(state, optionId);
      }, function (_, optionId) {
        return optionId;
      }, function (product, optionId) {
        var option = ((product === null || product === void 0 ? void 0 : product.options) || []).find(function (_ref17) {
          var id = _ref17.id,
            short_code = _ref17.short_code;
          return optionId === id || optionId === short_code;
        });
        return option;
      });
    }),
    popupGetPopupByProductId: new Duck.Selector(function () {
      return createSelector(duck.selectors.allPopups, function (_, productId) {
        return productId;
      }, function (allPopups, productId) {
        var popup = allPopups.find(function (_temp3) {
          var _ref18 = _temp3 === void 0 ? {} : _temp3,
            products = _ref18.products;
          return products ? products.some(function (product) {
            return (product === null || product === void 0 ? void 0 : product.id) === productId;
          }) : false;
        });
        return popup || {};
      });
    }),
    popupGetPopupByProductOptionId: new Duck.Selector(function () {
      return createSelector(duck.selectors.allPopups, function (_, optionId) {
        return optionId;
      }, function (allPopups, optionId) {
        var popup = allPopups.find(function (_temp4) {
          var _ref19 = _temp4 === void 0 ? {} : _temp4,
            products = _ref19.products;
          return products ? products.some(function (product) {
            return product === null || product === void 0 ? void 0 : product.options.find(function (option) {
              return (option === null || option === void 0 ? void 0 : option.id) === optionId || (option === null || option === void 0 ? void 0 : option.short_code) === optionId;
            });
          }) : false;
        });
        return popup || {};
      });
    }),
    popupGetPopupById: new Duck.Selector(function () {
      return createSelector(duck.selectors.allPopups, function (_, popupId) {
        if (popupId === void 0) {
          popupId = '';
        }
        return popupId ? popupId.toLowerCase() : '';
      }, function (allPopups, popupId) {
        var popup = allPopups.find(function (popup) {
          return ((popup === null || popup === void 0 ? void 0 : popup.id) === popupId || (popup === null || popup === void 0 ? void 0 : popup.short_code) === popupId) && popup.fetched;
        });

        // else it was never fetched
        if (!popup) {
          popup = allPopups.find(function (popup) {
            return (popup === null || popup === void 0 ? void 0 : popup.id) === popupId || (popup === null || popup === void 0 ? void 0 : popup.short_code) === popupId;
          });
        }
        return popup;
      });
    }),
    popupGetProductFields: function popupGetProductFields(state, productId, _fields) {
      var product = duck.selectors.popupGetProductById(state, productId);
      var customPropertyValues = duck.selectors.customProperties(state) || {};
      var fields = _fields || (product === null || product === void 0 ? void 0 : product.fields) || [];
      return prepareFields(fields, customPropertyValues);
    },
    popupGetFields: new Duck.Selector(function () {
      return createSelector(duck.selectors.popupGetPopupById, duck.selectors.customProperties, function (popup, customPropertyValues) {
        if (customPropertyValues === void 0) {
          customPropertyValues = {};
        }
        return prepareFields((popup === null || popup === void 0 ? void 0 : popup.fields) || [], customPropertyValues);
      });
    }),
    popupGetProductById: new Duck.Selector(function () {
      return createSelector(duck.selectors.allPopups, function (_, productId) {
        return productId;
      }, function (allPopups, productId) {
        var products = allPopups.reduce(function (acc, _temp5) {
          var _ref20 = _temp5 === void 0 ? {} : _temp5,
            products = _ref20.products;
          return [].concat(acc, products ? products : []);
        }, []);
        var product = products.find(function (_ref21) {
          var id = _ref21.id;
          return id === productId;
        });
        return product;
      });
    }),
    popupIsPledge: function popupIsPledge(state, _temp6) {
      var _ref22 = _temp6 === void 0 ? {} : _temp6,
        productId = _ref22.productId,
        optionId = _ref22.optionId;
      if (productId) {
        var product = duck.selectors.popupGetProductById(state, productId);
        return product === null || product === void 0 ? void 0 : product.pledge_mode;
      }
      if (optionId) {
        var _product = duck.selectors.popupGetProductByProductOptionId(state, optionId);
        return _product === null || _product === void 0 ? void 0 : _product.pledge_mode;
      }
      return null;
    },
    getFirstOptionTypeOfPopup: function getFirstOptionTypeOfPopup(popup) {
      var _popup$products2, _popup$products2$, _popup$products2$$opt, _popup$products2$$opt2;
      var type = popup === null || popup === void 0 ? void 0 : (_popup$products2 = popup.products) === null || _popup$products2 === void 0 ? void 0 : (_popup$products2$ = _popup$products2[0]) === null || _popup$products2$ === void 0 ? void 0 : (_popup$products2$$opt = _popup$products2$.options) === null || _popup$products2$$opt === void 0 ? void 0 : (_popup$products2$$opt2 = _popup$products2$$opt[0]) === null || _popup$products2$$opt2 === void 0 ? void 0 : _popup$products2$$opt2.type;
      if ((popup === null || popup === void 0 ? void 0 : popup.type) !== 'offer' || !type) {
        return null;
      }
      return type;
    },
    passNewRegular: function passNewRegular(popup) {
      var type = duck.selectors.getFirstOptionTypeOfPopup(popup);
      return type === 'pass';
    },
    subscriptionExistingSwitch: function subscriptionExistingSwitch(state, option) {
      // console.log('subscriptionExistingSwitch', state, option)
      return false;
    },
    subscriptionNewPledge: function subscriptionNewPledge(state, option) {
      // console.log('subscriptionNewPledge', state, option)
      return false;
    },
    subscriptionNewRegular: function subscriptionNewRegular(state, option) {
      // console.log('subscriptionNewRegular', state, option)
      return false;
    },
    getDefaultPopup: new Duck.Selector(function () {
      return createSelector(duck.selectors.topScopeLoader, duck.selectors.userStatus, function (_ref23, userStatus) {
        var _ref23$default_regist = _ref23.default_registered_popup,
          default_registered_popup = _ref23$default_regist === void 0 ? {} : _ref23$default_regist,
          _ref23$default_anonym = _ref23.default_anonymous_popup,
          default_anonymous_popup = _ref23$default_anonym === void 0 ? {} : _ref23$default_anonym;
        return userStatus === 'anonymous' ? default_anonymous_popup : default_registered_popup;
      });
    }),
    getDefaultRegisteredPopup: new Duck.Selector(function () {
      return createSelector(duck.selectors.topScopeLoader, function (_temp7) {
        var _ref24 = _temp7 === void 0 ? {} : _temp7,
          default_registered_popup = _ref24.default_registered_popup;
        return default_registered_popup;
      });
    }),
    getDefaultAnonPopup: new Duck.Selector(function () {
      return createSelector(duck.selectors.topScopeLoader, function (_temp8) {
        var _ref25 = _temp8 === void 0 ? {} : _temp8,
          default_anonymous_popup = _ref25.default_anonymous_popup;
        return default_anonymous_popup;
      });
    }),
    getPaymentPopupCustomTextFileName: new Duck.Selector(function () {
      return createSelector(duck.selectors.getDefaultPopup, function (_temp9) {
        var _custom_text$payment;
        var _ref26 = _temp9 === void 0 ? {} : _temp9,
          custom_text = _ref26.custom_text;
        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$payment = custom_text.payment) === null || _custom_text$payment === void 0 ? void 0 : _custom_text$payment.file_name;
      });
    }),
    getPaymentPopupCustomTextFileNameById: new Duck.Selector(function () {
      return createSelector(duck.selectors.popupGetPopupById, function (_temp10) {
        var _custom_text$payment2;
        var _ref27 = _temp10 === void 0 ? {} : _temp10,
          custom_text = _ref27.custom_text;
        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$payment2 = custom_text.payment) === null || _custom_text$payment2 === void 0 ? void 0 : _custom_text$payment2.file_name;
      });
    }),
    getAckPopupCustomTextFileNameById: new Duck.Selector(function () {
      return createSelector(duck.selectors.popupGetPopupById, function (_temp11) {
        var _custom_text$ack_defa, _custom_text$ack_defa2;
        var _ref28 = _temp11 === void 0 ? {} : _temp11,
          custom_text = _ref28.custom_text,
          type = _ref28.type;
        return !(type !== null && type !== void 0 && type.startsWith('signup_')) ? custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$ack_defa = custom_text.ack_default_payment) === null || _custom_text$ack_defa === void 0 ? void 0 : _custom_text$ack_defa.file_name : custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$ack_defa2 = custom_text.ack_default_signup) === null || _custom_text$ack_defa2 === void 0 ? void 0 : _custom_text$ack_defa2.file_name;
      });
    }),
    getSignupPopupCustomTextFileNameById: new Duck.Selector(function () {
      return createSelector(duck.selectors.popupGetPopupById, function (_temp12) {
        var _custom_text$signup;
        var _ref29 = _temp12 === void 0 ? {} : _temp12,
          custom_text = _ref29.custom_text;
        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$signup = custom_text.signup) === null || _custom_text$signup === void 0 ? void 0 : _custom_text$signup.file_name;
      });
    }),
    getTrialCustomAckFileNameById: new Duck.Selector(function () {
      return createSelector(duck.selectors.popupGetPopupById, function (_temp13) {
        var _custom_text$ack_tria;
        var _ref30 = _temp13 === void 0 ? {} : _temp13,
          custom_text = _ref30.custom_text;
        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$ack_tria = custom_text.ack_trial) === null || _custom_text$ack_tria === void 0 ? void 0 : _custom_text$ack_tria.file_name;
      });
    }),
    getSingleDonoCustomAckFileNameById: new Duck.Selector(function () {
      return createSelector(duck.selectors.popupGetPopupById, function (_temp14) {
        var _custom_text$ack_dona;
        var _ref31 = _temp14 === void 0 ? {} : _temp14,
          custom_text = _ref31.custom_text;
        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$ack_dona = custom_text.ack_donation_single) === null || _custom_text$ack_dona === void 0 ? void 0 : _custom_text$ack_dona.file_name;
      });
    }),
    getRecurringDonoCustomAckFileNameById: new Duck.Selector(function () {
      return createSelector(duck.selectors.popupGetPopupById, function (_temp15) {
        var _custom_text$ack_dona2;
        var _ref32 = _temp15 === void 0 ? {} : _temp15,
          custom_text = _ref32.custom_text;
        return custom_text === null || custom_text === void 0 ? void 0 : (_custom_text$ack_dona2 = custom_text.ack_donation_recurring) === null || _custom_text$ack_dona2 === void 0 ? void 0 : _custom_text$ack_dona2.file_name;
      });
    })
  };
};
var popups$1 = popups;

export { popups$1 as default };
//# sourceMappingURL=popups.js.map
